export { default } from "./PayProducts"
